exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".email-template-triggers{padding:20px}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/email-template/TriggerList.vue"],"names":[],"mappings":"AACA,yBACE,YAAc,CACf","file":"TriggerList.vue","sourcesContent":["\n.email-template-triggers {\n  padding: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-056de16c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/admin/email-template/TriggerList.vue
// module id = 2615
// module chunks = 0